export default "__VITE_ASSET__DKtyVsZ2__"